<template lang="html">
  <div class="floorplan-grid-tile container-fluid
  pt-4 pb-2">
    <floorplan-info-short :floorplan="floorplan"/>
    <div>
      <div class="floorplan-grid-tile-image my-3"
      :style="{'background-image': 'url(' + thumbUrl + ')'} "/>
    </div>
    <div class="d-flex justify-content-between align-items-end">
      <div class="d-flex align-items-center">
        <floorplan-favourite-toggle :floorplan="floorplan" />
      </div>
      <div class="details">
        <i class="fas fa-angle-right"></i> {{ selectLabel }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import FloorplanInfoShortComponent from '@/components/Floorplan/FloorplanInfoShort';
import FloorplanFavouriteToggleComponent from '@/components/Floorplan/FloorplanFavouriteToggle';

export default {
  name: 'floorplan-grid-tile',
  props: {
    floorplan: {
      type: Object,
      default: () => {}
    },
    selectLabel: {
      type: String,
      default: 'SELECT'
    }
  },
  computed: {
    ...mapState({
      assetsUrl: state => state.project.assetsUrl
    }),
    thumbUrl() {
      return this.assetsUrl + this.floorplan.assets.floorplan.url;
    },
  },
  components: {
    'floorplan-info-short': FloorplanInfoShortComponent,
    'floorplan-favourite-toggle': FloorplanFavouriteToggleComponent
  }
};
</script>

<style lang="scss" scoped>
.floorplan-grid-tile {
  color: var(--text-dark);
  cursor: pointer;

  &:active {
    background-color: var(--highlight);
  }

  .details .fa-angle-right {
    padding-right: 5px;
    transition: padding-right 0.3s ease;
  }

  &:hover .details {
    color: var(--action);

    .fa-angle-right {
      padding-right: 0;
    }
  }
}

.floorplan-grid-tile-image {
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  height: 15rem;
}

.details {
  font-family: Scandia-Regular, sans-serif;
  position: relative;
  color: black;
}
</style>



// WEBPACK FOOTER //
// src/components/Floorplan/FloorplanGridTile.vue